import queryString from 'query-string';
import {CheckoutLayout} from 'components/Checkouts/CheckoutSC';
import CheckoutWrapper from 'components/Checkouts/Checkout/common/CheckoutWrapper';
import BigSpinner from 'utils/Spinner/BigSpinner';
import FailedState from 'utils/ResponseState/FailedState';
import {getError} from 'utils/helpers';
import {useLASGValidate} from './useLASGQuery';
import LASGHeader from './LASGHeader';
import LASGPaymentView from './LASGPaymentView';
import LASGLookupForm from './LASGLookupForm';

const LASG = ({location}) => {
    const {ref: urlRef, Type: urlType} = queryString.parse(location?.search);
    const hasRefParams = !!urlRef && !!urlType;

    const {invoiceData, isLoading, isError, error} = useLASGValidate(urlRef, urlType);

    const renderContent = () => {
        if (invoiceData) {
            return <LASGPaymentView invoiceData={{...invoiceData, reference: urlRef}} />;
        }

        if (hasRefParams && isLoading) {
            return (
                <CheckoutWrapper isFrame={false} sendEvent={() => {}}>
                    <LASGHeader />
                    <div className="d-flex align-items-center justify-content-center py-5">
                        <BigSpinner />
                    </div>
                </CheckoutWrapper>
            );
        }

        if (hasRefParams && isError) {
            return (
                <CheckoutWrapper isFrame={false} sendEvent={() => {}}>
                    <LASGHeader />
                    <FailedState errorMsg={getError(error?.response?.data ?? error)} />
                </CheckoutWrapper>
            );
        }

        return <LASGLookupForm />;
    };

    return (
        <CheckoutLayout className="checkout">
            <div className="checkout__container">
                <div className="checkout__main py-4">{renderContent()}</div>
            </div>
        </CheckoutLayout>
    );
};

export default LASG;
